module.exports = __webpack_public_path__ + "assets/6754c15b796e27d064c369d055c8e68c.svg";